export default {"src":"/polygon/_next/static/media/xtokenImage.4c431352.svg","height":80,"width":80};